import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] ${
      dark ? "text-accent-soft" : "text-brand-light"
    }`}
  >
    <span className={`h-px w-10 ${dark ? "bg-accent-soft" : "bg-brand-light"}`} />
    {children}
  </span>
);
